@if (canReadContacts()) {
  <section fxFlex fxLayout="column" fxLayoutGap="10px">
    <iot-platform-ui-detail-popup-section-header
      headerTitle="{{ (contacts()?.length > 1 ? 'IOT_DICTIONARY.CONTACTS' : 'IOT_DICTIONARY.CONTACT') | translate }} ({{ contacts()?.length }})"
    />
    <iot-platform-ui-detail-contact-card [contacts]="contacts()" />
  </section>
}
